export default __webpack_public_path__ + "static/media/RJS.63d79710.png";